// @flow

import Api from './ApiBase';

class WorkTypesApi extends Api {
  fetch = async () => {
    const json = await this.request('work_types');
    const data = await this.deserialize(json);

    return { data };
  }
}

export default new WorkTypesApi();
